import { getResource, putResource } from './index';
import { Constants } from '../constants';
import {UserAttributeType} from '../types/auth_types';

export const getCustomerList = async (
  user: UserAttributeType,
  currentBusinessId: string,
  pageNumber = 1,
  q = ''
) => {
  return await getResource(
    `/v1/businesses/${currentBusinessId}/customers?page=${pageNumber}&per_page=${Constants.PerPageCount.Customers}&q=${q}`,
    user.token
  );
};

export const customerBlock = async (user: UserAttributeType, currentBusinessId: string, customerId: number) => {
  return await putResource(
    `/v1/businesses/${currentBusinessId}/customers/${customerId}/block`,
    {},
    user.token
  );
};

export const customerUnblock = async (user: UserAttributeType, currentBusinessId: string, customerId: number) => {
  return await putResource(
    `/v1/businesses/${currentBusinessId}/customers/${customerId}/unblock`,
    {},
    user.token
  );
};

export const getCustomerRatingList = async (
  user: UserAttributeType,
  customerId: number,
  pageNumber = 1
) => {
  return await getResource(
    `/v1/business/customers/${customerId}/customer_ratings?type=${Constants.RatingType.Booking}&page=${pageNumber}&per_page=${Constants.PerPageCount.CustomerRatings}`,
    user.token
  );
};
